export default __webpack_public_path__ + "static/media/placeholder-platinum-featured.2ab9e7e3.svg";